import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss']
})
export class EmptyComponent implements OnInit {
@Input() header:any;
@Input() text:any;

  constructor() { }

  ngOnInit() {
  }

}
